import { EventEmitter } from '@stencil/core';
import { CookieDisclaimerControllableComponentAttributes } from './CookieDisclaimerControllableComponentAttributes.interface';

class CookieDisclaimerDefaults implements CookieDisclaimerControllableComponentAttributes {
  readonly forceVisible: boolean = false;

  // Cookie checkbox Zustände
  readonly statisticCookies = false;
  readonly personalCookies = false;
  readonly marketingCookies = false;

  // Sichtbarkeit des Modals (falls visible = auto)
  readonly autoVisible = false;

  readonly bahfCdAcceptAll: EventEmitter;
  readonly bahfCdAcceptSelection: EventEmitter<{
    cookieConsentChecked: boolean;
    personalizationConsentChecked: boolean;
    marketingConsentChecked: boolean;
  }>;
}

export const COOKIE_DISCLAIMER_DEFAULTS = new CookieDisclaimerDefaults();
